import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Network/ONVIF/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemOnvifAdminPerm';
import ONVIFTable from 'components/Web_User_Interface/1440p_Series/Network/ONVIF/onvifTable';
import YoutubeVideoCardONVIFSynology from 'components/Web_User_Interface/1440p_Series/Network/ONVIF/YoutubeVideoCardONVIFSynology';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  ONVIFTable,
  YoutubeVideoCardONVIFSynology,
  BreadCrumbs,
  SEOHelmet,
  React
};